export const shouldRedirectToLoginPage = (errorMessage?: string) => {
  if (!errorMessage) return false;

  if (errorMessage.includes('Incorrect username or password')) return true;

  return false;
};
